export const commentItemStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '12px 16px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  borderRadius: '8px',
};

export const commentTextStyles = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};
